import angular from 'angular';

// TODO find a better name
import OnBlurDirective, { selector } from './on-blur.directive';

export default angular
    .module('application.directive.on-blur', [])
    .directive(selector, OnBlurDirective);



// WEBPACK FOOTER //
// ./src/application/directive/on-blur/index.js